import OfferDetails from '@/components/Onramp/Offer/Details.vue';
import OfferFull from '@/components/Onramp/Offer/Full.vue';

export default {
  OfferDetails,
  OfferFull
};
